/**
 * Bridge for sending feature requests from the web app to the VIVERSE native
 * mobile app shell (Flutter WebView). No-ops outside that WebView.
 */

type MobileAppFeature = 'enter-kids-mode' | 'enter-offline-games' | 'web-back'

type MobileAppMessage = {
  feature: MobileAppFeature
  data?: string
  url?: string
}

type FlutterWebview = {
  postMessage: (payload: string) => void
}

function getFlutterWebview(): FlutterWebview | undefined {
  if (typeof window === 'undefined' || !('flutterWebview' in window)) return undefined
  return (window as unknown as { flutterWebview: FlutterWebview }).flutterWebview
}

export function postMessageToMobileApp(message: MobileAppMessage) {
  const flutterWebview = getFlutterWebview()
  if (!flutterWebview) return

  flutterWebview.postMessage(JSON.stringify(message))
}
